import { EnrollmentDocumentType } from "../../../types/Student";
import { post } from "../../../utils/axios-config";
import { ENROLLMENTS_DOCUMENTS } from "../../../utils/constants";


export const createEnrollmentDocument = async (data: EnrollmentDocumentType) => await post<EnrollmentDocumentType, string>(ENROLLMENTS_DOCUMENTS, data);